import CheckmarkCircleFilled from 'mini-fluent-svg-icons/lib/icons/CheckmarkCircleFilled';
import CheckmarkCircleRegular from 'mini-fluent-svg-icons/lib/icons/CheckmarkCircleRegular';
import React from 'react';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';

const styles = require('./SelectAllIcon.scss');

interface SelectAllIconProps {
    isAllSelected?: boolean;
    classNames?: boolean;
}

export const SelectAllIcon: React.FC<SelectAllIconProps> = props => (
    <FluentSvgIcon
        icon={props.isAllSelected ? CheckmarkCircleFilled : CheckmarkCircleRegular}
        iconContainerStyles={styles.selectAllIcon}
    />
);
